import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-fab',
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.scss'],
})
export class FabComponent implements OnInit {

  @Input('value') itemCount: number = 0
  @Input('icon') icon: string = 'add'
  @Input('changeQuantity') changeQuantity: boolean = true
  @Output('change') change: EventEmitter<number> = new EventEmitter<number>()
  private _itemCount$: Subject<number> = new Subject<number>()
  public open: boolean = false

  constructor() { }

  ngOnInit() {
    this._itemCount$.subscribe({
      next: value => {
        if(this.changeQuantity) this.itemCount = this.itemCount + value
        this.change.emit(this.itemCount)
      }
    })
  }

  ngOnDestroy() {
    this._itemCount$.unsubscribe()
  }

  sum(value: number) {
    this._itemCount$.next(value)
  }

}
